module.exports = __webpack_public_path__ + "img/receipt20.d9727f1f.png";